import React from 'react';
import { Link } from 'react-router';
import api from 'api';
import path from 'path';
import { PMS_URL } from '../../../../config';

const AppLink = ({ to, children, ...props }) => {
  const root = props.customRoot || props.root;
  const url = path.join(PMS_URL, root, to);
  return (
    <Link to={ url }>{ children }</Link>
  );
};

export default api.connect(AppLink, 'routing', { noClearOnUnmount: true });



// WEBPACK FOOTER //
// ./src/frontend/modules/routing/containers/AppLink.jsx